const audios_data = [
    {
        image: "https://placehold.co/600x200?text=Selecciona+o+arrastra+tu+imagen",
        title: '',
        audio: null,
    },
]

const config = {
    type: 'MULTIMEDIA',
    component: "Smu02",
    portrait: "/img/container/S-MU-02.jpg",
    body: {
        title:'',
        audios: audios_data
    },
}

export { config }